import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { PageAboutMarketsProps } from 'client/bundles/types';
import Breadcrumbs from 'client/components/breadcrumbs';
import LangContext from 'client/utils/lang-context';

import MarketsTable from './markets-table';

const b = cn('about-markets');
const bPageTitle = cn('page-title');
const bPageText = cn('page-text');

interface Props {
    marketsData?: PageAboutMarketsProps;
}

class AboutMarkets extends Component<Props> {
    static contextType = LangContext;

    render() {
        if (!this.props.marketsData) {
            return;
        }

        const { title, text, 'table-header': header, markets } = this.props.marketsData;
        const { dictionary } = this.context;

        return (
            <div className={b()}>
                <Breadcrumbs link="/about" text={dictionary.about} />

                <h1 className={bPageTitle({ type: 'border' })}>{title}</h1>
                <div className={bPageText()} dangerouslySetInnerHTML={{ __html: text }} />

                <div className={b('table')}>
                    <MarketsTable header={header} markets={markets} />
                </div>
            </div>
        );
    }
}

export default AboutMarkets;
